import { axiosInstance } from "../../../../Services";
import { MMH_KEYWORDS_PATH, USE_MOCK } from "./config";
import { mockSearchKeywords } from "../mock/mockApi";

// Type-ahead for the per-image keyword tagger.
// GET /internal/mmh-products/keywords?q=  →  { data: ["3d elevation", ...] }
export const SearchKeywords = async (query) => {
  if (USE_MOCK) {
    return mockSearchKeywords(query);
  }
  return axiosInstance.get(MMH_KEYWORDS_PATH, { params: { q: query } });
};

export default SearchKeywords;
